export const getItemFromStore = ({
  key,
  defaultValue = null,
  store = localStorage,
}: {
  key: string;
  defaultValue?: unknown;
  store?: Storage;
}) => {
  try {
    const item = store.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error parsing item "${key}" from store:`, error);
  }
  return defaultValue;
};

export const setItemToStore = ({
  key,
  payload,
  store = localStorage,
}: {
  key: string;
  payload: unknown;
  store?: Storage;
}) => store.setItem(key, JSON.stringify(payload));

// ===============================
// Cookie
// ===============================
export const getCookieValue = (name: string) => {
  const value = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)');

  return value ? value.pop() : null;
};

export const createCookie = (name: string, value: unknown, cookieExpireTime: number) => {
  const date = new Date();
  date.setTime(date.getTime() + cookieExpireTime);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
